import { getRequest, postRequest } from '../request/request.service';
import {
  AvailableAgent,
  EndConferencePayload,
  EndConferenceResponse,
  QueueStats,
  StartConferencePayload,
  StartConferenceResponse,
  VoiceTokenResponse,
  WebchatConversation,
  WebchatHistoryParams,
  WebchatHistoryResponse,
  WebchatMessage,
} from './webchat.service.types';

const WEBCHAT_URL = 'webchat_conversations';

export function getWebchatConversations(params?: { status?: string }) {
  return getRequest<WebchatConversation[]>(WEBCHAT_URL, { params });
}

export function getWebchatMessages(id: number, since?: string) {
  const params = since ? { since } : undefined;
  return getRequest<WebchatMessage[]>(`${WEBCHAT_URL}/${id}/messages`, { params });
}

export function sendAgentMessage(id: number, text: string) {
  return postRequest<{ ok: boolean }>(`${WEBCHAT_URL}/${id}/send_agent_message`, {
    data: { text },
  });
}

export type ClaimResponse = WebchatConversation & {
  mode?: 'translated_bridge';
  agent_language?: string;
  visitor_language?: string;
};

export function claimConversation(id: number, translate: boolean, agentLanguage?: string) {
  return postRequest<ClaimResponse>(`${WEBCHAT_URL}/${id}/claim`, {
    data: { translate, agent_language: agentLanguage },
  });
}

export function closeConversation(id: number, reason?: string) {
  return postRequest<{ ok: boolean }>(`${WEBCHAT_URL}/${id}/close`, {
    data: { reason },
  });
}

export function transferConversation(id: number, agentId: number, notes?: string) {
  return postRequest<WebchatConversation>(`${WEBCHAT_URL}/${id}/transfer`, {
    data: { agent_id: agentId, notes },
  });
}

export function getWebchatHistory(params: WebchatHistoryParams) {
  return getRequest<WebchatHistoryResponse>(`${WEBCHAT_URL}/history`, { params });
}

export function getAvailableAgents() {
  return getRequest<AvailableAgent[]>(`${WEBCHAT_URL}/available_agents`);
}

export function getQueueStats() {
  return getRequest<QueueStats>(`${WEBCHAT_URL}/queue_stats`);
}

export function updateNotes(id: number, notes: string) {
  return postRequest<{ ok: boolean; notes: string }>(`${WEBCHAT_URL}/${id}/update_notes`, {
    data: { notes },
  });
}

export function markRead(id: number) {
  return postRequest<{ unread_count: number }>(`${WEBCHAT_URL}/${id}/mark_read`);
}

export function toggleAvailability() {
  return postRequest<{ webchat_available: boolean }>(`${WEBCHAT_URL}/toggle_availability`);
}

export function getVoiceToken(conversationId: number) {
  return postRequest<VoiceTokenResponse>(`${WEBCHAT_URL}/${conversationId}/voice_token`);
}

export function startConference(conversationId: number, data: StartConferencePayload) {
  return postRequest<StartConferenceResponse>(`${WEBCHAT_URL}/${conversationId}/start_conference`, {
    data,
  });
}

export function endConference(conversationId: number, data: EndConferencePayload) {
  return postRequest<EndConferenceResponse>(`${WEBCHAT_URL}/${conversationId}/end_conference`, {
    data,
  });
}

export function getTranslationAudioUrl(s3Key: string) {
  return getRequest<{ url: string }>(`${WEBCHAT_URL}/translation_audio_url`, {
    params: { s3_key: s3Key },
  });
}
